module.exports = __webpack_public_path__ + "img/ilustra8.fd778da4.png";